import Client from './ApiClient'

const resource = 'registration-form'

const getAll = (page = 1, perPage = 10) => {
  return Client.get(`${resource}?page=${page}&perPage=${perPage}`)
}

const update = (id, data) => {
  return Client.put(`${resource}/${id}`, data)
}

export default { getAll, update }
